var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_c('h1',{staticClass:"display-2 primary--text"},[_vm._v("Error, 401")]),_c('p',[_vm._v(" Unauthorized ")]),_c('v-btn',{staticClass:"mr-2",attrs:{"to":{ name: 'LandingPage' },"color":"primary","outlined":""}},[_vm._v(" Go back home ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }